import { BaseComponent, BaseComponentAttrs } from "../base/baseComponent";
import { CompType } from "../base/baseEnum";
import { LangText } from "../base/baseType";

/** 跑马灯数据项接口 */
export interface MarqueeItem {
  /** 唯一标识 */
  key: number;
  /** 状态 */
  status: number;
  /** 点击ID */
  click_id: number;
  /** 点击参数 */
  click_params: string;
  /** 内容语言 */
  context_lang: LangText;
}

/** 跑马灯组件属性接口 */
export interface MarqueeAttrs extends BaseComponentAttrs {
  /** 标题类型 */
  title_type: number;
  /** 标题图标 */
  title_icon: string;
  /** 标题文本 */
  title_text: LangText;
  /** 数据列表 */
  data_list: MarqueeItem[];
}

/** 跑马灯组件类 */
export class MarqueeComponent extends BaseComponent<MarqueeAttrs> {
  constructor(data: Partial<BaseComponent<MarqueeAttrs>> = {}) {
    super(data);
    this.type = CompType.marquee;
  }

  /** 获取标题类型 */
  public getTitleType(): number {
    return this.attrs.title_type;
  }

  /** 设置标题类型 */
  public setTitleType(type: number): void {
    this.setAttrs({ title_type: type });
  }

  /** 获取标题图标 */
  public getTitleIcon(): string {
    return this.attrs.title_icon;
  }

  /** 设置标题图标 */
  public setTitleIcon(icon: string): void {
    this.setAttrs({ title_icon: icon });
  }

  /** 获取标题文本 */
  public getTitleText(): LangText {
    return this.attrs.title_text;
  }

  /** 设置标题文本 */
  public setTitleText(text: LangText): void {
    this.setAttrs({ title_text: text });
  }

  /** 获取跑马灯数据列表 */
  public getMarqueeItems(): MarqueeItem[] {
    return this.attrs.data_list;
  }

  /** 设置跑马灯数据列表 */
  public setMarqueeItems(items: MarqueeItem[]): void {
    this.setAttrs({ data_list: items });
  }

  /** 获取指定语言的标题 */
  public getTitleByLang(lang: string): string {
    return this.attrs.title_text?.[lang] || "";
  }

  /** 获取指定语言的内容 */
  public getContentByLang(item: MarqueeItem, lang: string): string {
    return item.context_lang?.[lang] || "";
  }
}

// 使用示例
// const marqueeData: Partial<BaseComponent<MarqueeAttrs>> = {
//   id: "670a83352a86799e98aa91b6",
//   type: CompType.marquee,
//   variant: "",
//   title: "跑马灯标题1111111",
//   status: 1,
//   sort: 0,
//   login_type: LoginType.Login,
//   recharge_type: RechargeType.Recharge,
//   fixed_top: 0,
//   key: "marquee_1728742196",
//   show_rtp: false,
//   height: "",
//   attrs: {
//     title_type: 2,
//     title_icon: "new-5016",
//     title_text: {
//       "1": "跑马灯标题222",
//       "4": "跑马灯标题1111111",
//     },
//     data_list: [
//       {
//         context_lang: {
//           "1": "Welcome to the entertainment city, a lot of rewards are waiting for you!1888888",
//           "4": "歡迎來到娛樂城，大量獎勵等你領取！",
//           "11": "Bem-vindo à cidade do entretenimento, muitas recompensas estão esperando por você!88888",
//           "12": "¡Bienvenido a la ciudad del entretenimiento, te esperan muchas recompensas!88888",
//         },
//         click_id: 9,
//         click_params: "game_list_20250102",
//         key: 1729065853596,
//         status: 1,
//       },
//     ],
//   },
// };
